import type { ReactNode } from 'react';
import type { UseQueryResult } from '@tanstack/react-query';
import { errorMessage } from '../api/error';
import { ErrorState, LoadingState } from './EmptyState';

interface QueryBoundaryProps<T> {
  query: UseQueryResult<T>;
  children: (data: T) => ReactNode;
  loadingLabel?: string;
}

/** Resuelve carga, error y exito de una query sin repetir el mismo bloque. */
export function QueryBoundary<T>({
  query,
  children,
  loadingLabel,
}: QueryBoundaryProps<T>): JSX.Element {
  if (query.isPending) return <LoadingState label={loadingLabel} />;
  if (query.isError) {
    return (
      <ErrorState message={errorMessage(query.error)} onRetry={() => void query.refetch()} />
    );
  }
  return <>{children(query.data as T)}</>;
}
